exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../node_modules/css-loader/index.js!../static/css/Components/GlobalStatsNavbar.css"), "");

// module
exports.push([module.id, "\n.global-stats-group:not(:last-of-type) {\r\n  border-right: 1px solid lightgray;\n}\r\n", ""]);

// exports
